export const siteConfig = {
  name: '17一起草',
  tagline: '让每一次写作都更轻松、更高效、更有价值',
  description: '17一起草是您的首选平台，汇聚海量内容创作资源，助力用户高效完成写作任务。立即体验17一起草带来的全新创作方式。',
  url: 'https://17yiqicao.com',
  logo: '17一起草',
};

export const categories = [
  { slug: 'xiezuo-jiqiao', name: '写作技巧', description: '掌握实用写作技巧，提升文字表达能力', icon: 'ri-quill-pen-line' },
  { slug: 'chuangyi-linggan', name: '创意灵感', description: '激发无限创意灵感，突破写作瓶颈', icon: 'ri-lightbulb-line' },
  { slug: 'neirong-yingxiao', name: '内容营销', description: '内容即流量，打造高转化营销文案', icon: 'ri-megaphone-line' },
  { slug: 'xueshu-xiezuo', name: '学术写作', description: '严谨规范的学术论文写作指导', icon: 'ri-book-open-line' },
  { slug: 'shangye-wenan', name: '商业文案', description: '商务文书、企划方案写作全攻略', icon: 'ri-briefcase-line' },
  { slug: 'xinmeiti-xiezuo', name: '新媒体写作', description: '公众号、短视频脚本创作宝典', icon: 'ri-smartphone-line' },
];

export const articles = [
  {
    slug: 'ruhe-kaishi-xiezuo',
    title: '如何克服写作恐惧：从零开始的第一步',
    excerpt: '每个人都曾面对空白文档感到茫然。本文分享五个实用方法，帮助你克服写作恐惧，迈出创作的第一步。',
    content: `## 为什么我们会害怕写作？

面对空白文档的那一刻，即使是经验丰富的写作者也会感到一丝紧张。这种恐惧源于对"不完美"的担忧——我们害怕写出来的东西不够好，害怕被他人评判。

## 五个克服写作恐惧的方法

### 1. 降低期望值
第一稿不需要完美。记住：所有优秀的作品都是在反复修改中诞生的。允许自己写"糟糕的初稿"，这是通往好作品的必经之路。

### 2. 设定小目标
不要想着"今天要写完一整篇文章"。从"写100个字"开始，或者"写15分钟"。小目标更容易达成，达成后的成就感会激励你继续。

### 3. 建立写作习惯
每天固定时间写作，哪怕只有20分钟。习惯的力量远大于意志力。当你把写作变成像刷牙一样的日常，恐惧自然消散。

### 4. 使用大纲先行
在正式写作前，先列一个简单的大纲。有了骨架，填充内容就变得容易很多。这就像有了地图再去旅行，方向明确。

### 5. 接受反馈，但不被定义
请信任的朋友阅读你的作品，但记住：他们的意见只是参考，不是判决。你是自己作品的第一责任人。

## 结语

写作是一项可以通过练习精进的技能。每一次落笔，都是在超越昨天的自己。从今天开始，写点什么吧。`,
    category: 'xiezuo-jiqiao',
    categoryName: '写作技巧',
    date: '2026-07-28',
    readTime: 8,
    imageQuery: 'A warm minimalist study desk with notebook and pen bathed in soft morning sunlight, potted plant nearby, clean aesthetic, peaceful creative atmosphere, editorial photography style with warm amber tones and gentle shadows',
    imageSeq: 'article-01',
  },
  {
    slug: 'chuangyi-xiezuo-siwei',
    title: '打破思维定式：五种创意写作训练法',
    excerpt: '创意不是天赋，而是可以训练的能力。掌握这五种创意写作训练方法，让你的文字从平淡变得灵动。',
    content: `## 创意是可以训练的

很多人认为创意是一种天赋，要么天生就有，要么永远没有。这种想法大错特错。创意像肌肉一样，可以通过持续训练不断增强。

## 五种创意写作训练

### 1. 自由联想写作
给自己设定一个主题词，然后连续写15分钟，不停笔、不修改、不评判。让思维自由流动，你会发现意想不到的灵感。

### 2. 视角转换练习
同一件事，从不同角色的视角来写。比如"一个杯子被打碎了"，分别以杯子的主人、打碎杯子的小孩、以及杯子本身的视角来写。

### 3. 限制性创作
给自己设定限制条件：比如整段文字不能出现某个常用字，或者必须使用某个奇怪的比喻。限制反而能激发创意。

### 4. 感官描写训练
选择一个场景，只用听觉来描写，或者只用嗅觉。关掉视觉这个主导感官，其他感官会变得异常敏锐。

### 5. 跨界融合
将完全不相关的领域结合：用物理学概念解释爱情，用烹饪术语描写建筑设计。跨界碰撞是创意的最大来源。

## 持续训练

每天花15分钟进行以上一种训练，坚持21天，你会发现自己的思维变得截然不同。创意之门，由你亲手打开。`,
    category: 'chuangyi-linggan',
    categoryName: '创意灵感',
    date: '2026-07-25',
    readTime: 10,
    imageQuery: 'Colorful abstract paint splashes swirling in creative motion on white canvas, artistic explosion of warm coral and teal colors, inspiring creative energy, high detail editorial photography with soft lighting',
    imageSeq: 'article-02',
  },
  {
    slug: 'neirong-yingxiao-xinfa',
    title: '2026内容营销新趋势：从流量思维到价值思维',
    excerpt: '内容营销正在经历深刻变革。理解从流量思维到价值思维的转变，是每个内容创作者必须掌握的底层逻辑。',
    content: `## 内容营销的范式转移

过去十年，内容营销的核心是"流量"——追求更大的曝光量、更多的点击率。但2026年的今天，这种模式正面临瓶颈：流量成本攀升、用户注意力碎片化、算法频繁变动。

## 从流量到价值的转变

### 理解"价值思维"
价值思维的核心是：不是"我能获得多少流量"，而是"我能为用户创造多少价值"。当你的内容真正解决了用户的问题，流量会自然跟随。

### 深度优于广度
一篇深度解决某个具体问题的长文，效果远胜于十篇泛泛而谈的短文。2026年，搜索引擎和推荐算法都在奖励"真正有用的内容"。

### 建立内容IP
围绕核心专业领域，持续输出高质量内容，建立属于你自己的内容IP。这需要时间，但这是最稳固的护城河。

### 用户旅程思维
从用户第一次接触你的内容，到最终成为忠实读者，设计完整的内容旅程。每一篇文章都应该是这个旅程中的一个里程碑。

## 实操建议

1. 每月输出2-3篇深度内容，而非每天发布短文
2. 建立内容矩阵：图文+视频+播客，覆盖不同场景
3. 重视用户互动，从评论区获取内容灵感
4. 数据驱动优化，但不被数据绑架

## 结语

2026年，最好的内容营销策略就是——真诚地帮助你的用户。`,
    category: 'neirong-yingxiao',
    categoryName: '内容营销',
    date: '2026-07-22',
    readTime: 12,
    imageQuery: 'Modern marketing strategy visualized through floating holographic data charts and content icons in warm amber and teal, clean minimalist aesthetic, futuristic yet warm atmosphere, editorial style with soft ambient light',
    imageSeq: 'article-03',
  },
  {
    slug: 'xueshu-lunwen-jiegou',
    title: '学术论文写作指南：从选题到参考文献',
    excerpt: '全面解析学术论文的标准结构，从选题、文献综述到研究方法，每一步都有详细指导。',
    content: `## 学术论文的核心要素

一篇优秀的学术论文，不仅要有扎实的研究内容，更要有清晰严谨的结构。本文带你全面了解学术论文的标准写作流程。

## 论文结构全解析

### 1. 选题与研究问题
好的选题是成功的一半。选题应具备：创新性、可行性、重要性。将选题转化为清晰的研究问题是关键一步。

### 2. 文献综述
文献综述不是简单的罗列，而是对已有研究的批判性梳理。要找出研究空白，明确你的研究在学术版图中的位置。

### 3. 研究方法
清晰描述你的研究方法，让其他研究者可以复现你的研究。定量研究要说明样本、工具、分析步骤；定性研究要说明数据收集和分析框架。

### 4. 结果呈现
用表格和图表清晰展示研究发现，避免在结果部分加入过多的讨论和解读。

### 5. 讨论与分析
这是论文的灵魂部分。将你的发现与已有研究对话，解释你的结果意味着什么，指出研究局限。

### 6. 结论与展望
简洁有力地总结核心发现，提出未来研究方向。

## 写作建议

- 先写方法论和结果，再写引言和讨论
- 每天写500字，持续优于冲刺
- 善用参考文献管理工具
- 请同行评阅初稿`,
    category: 'xueshu-xiezuo',
    categoryName: '学术写作',
    date: '2026-07-20',
    readTime: 15,
    imageQuery: 'Elegant academic library with wooden shelves filled with books, warm reading lamp glow on a polished desk with open notebook, scholarly atmosphere, refined minimalist aesthetic, amber and ivory tones, editorial photography',
    imageSeq: 'article-04',
  },
  {
    slug: 'shangye-jihua-shu',
    title: '商业计划书写作秘籍：让投资人眼前一亮的秘诀',
    excerpt: '一份出色的商业计划书是融资成功的关键。本文揭示顶级商业计划书的核心要素和写作技巧。',
    content: `## 商业计划书的重要性

商业计划书不仅是融资工具，更是梳理商业逻辑的过程。一份好的商业计划书，能让投资人在5分钟内理解你的商业价值。

## 核心模块拆解

### 1. 执行摘要
这是最重要的部分——90%的投资人只看这一页就决定是否继续。必须包含：痛点、解决方案、市场规模、商业模式、团队优势、融资金额。

### 2. 市场分析
用数据说话。展示市场规模、增长趋势、目标用户画像。不要只说"市场很大"，要给出具体数字和来源。

### 3. 产品与服务
清晰说明你的产品是什么、解决什么问题、与竞品的差异化优势。一图胜千言。

### 4. 商业模式
你怎么赚钱？收入来源、定价策略、成本结构。要具体，不要模糊。

### 5. 团队介绍
投资就是投人。展示团队的核心能力和过往成就，说明为什么是你们来做这件事。

### 6. 财务预测
提供3-5年的财务预测，包含收入、成本、利润。保守估计比乐观估计更可信。

## 写作技巧

1. 用故事开场，用数据支撑
2. 每个观点都要有证据
3. 排版清晰，重点突出
4. 请第三方审阅，找出漏洞`,
    category: 'shangye-wenan',
    categoryName: '商业文案',
    date: '2026-07-18',
    readTime: 13,
    imageQuery: 'Professional business presentation scene with sleek laptop displaying charts, modern glass-walled conference room, warm ambient lighting, clean corporate aesthetic, amber and charcoal tones, editorial product photography',
    imageSeq: 'article-05',
  },
  {
    slug: 'gongzhonghao-baokuan',
    title: '公众号爆款文章公式：从选题到标题的完整攻略',
    excerpt: '拆解100篇10万+阅读量的公众号文章，总结出一套可复用的爆款公式，让你的文章也能刷屏朋友圈。',
    content: `## 爆款文章的底层逻辑

分析了100篇10万+文章后，我发现爆款并非偶然——它们都遵循着相似的底层逻辑。这篇文章将这些规律提炼为可操作的公式。

## 选题公式

### 1. 热点+专业角度
每当热点事件发生，从你的专业角度给出解读。比如你是法律从业者，就用法学视角解读热点事件。

### 2. 痛点+解决方案
找出目标读者最痛的点，给出切实可行的解决方案。痛点越具体，打开率越高。

### 3. 认知反差
挑战读者的固有认知。"你以为A，其实B"的结构非常吸引人点击。

## 标题公式

### 1. 数字+价值
"5个让你写作效率翻倍的技巧"比"如何提高写作效率"点击率高3倍。

### 2. 悬念+利益
制造好奇心缺口，同时暗示阅读收益。

### 3. 情绪词+场景
"崩溃！连续加班30天我学到了什么"——情绪词引发共鸣。

## 内容结构

### 开头：3秒钩子
用故事、数据、提问抓住注意力。

### 中间：干货分层
将内容分为3-5个要点，每个要点用小标题引导，增强可读性。

### 结尾：行动号召
引导读者点赞、在看、转发，或者引导关注公众号。

## 排版技巧

- 段落不超过5行
- 善用加粗和引用
- 配图要精美且相关
- 留白让阅读更轻松`,
    category: 'xinmeiti-xiezuo',
    categoryName: '新媒体写作',
    date: '2026-07-15',
    readTime: 11,
    imageQuery: 'Vibrant social media content creation workspace with smartphone displaying colorful feed, creative desk setup with warm lighting, modern influencer aesthetic, coral and teal accents, editorial style with soft ambient glow',
    imageSeq: 'article-06',
  },
  {
    slug: 'xiezuo-shengchanli',
    title: '写作生产力工具推荐：2026年必备的10款效率神器',
    excerpt: '工欲善其事，必先利其器。推荐10款经过实测的写作效率工具，让你的创作效率提升300%。',
    content: `## 为什么需要写作工具？

好的写作工具不仅节省时间，更能改变你的写作方式。2026年，AI辅助写作已经成为主流，但工具的选择比工具本身更重要。

## 10款必备写作工具

### 1. 专注写作：Typora
所见即所得的Markdown编辑器，界面极简，让你专注于文字本身。支持实时预览、多种导出格式。

### 2. 大纲工具：幕布
极佳的大纲和思维导图工具，适合构思阶段使用。层级结构清晰，一键切换大纲和导图视图。

### 3. 语法检查：Grammarly
英文写作必备。不仅能检查语法错误，还能优化句式、调整语气。

### 4. AI助手：Claude
2026年最强大的AI写作助手，可以帮你头脑风暴、拓展思路、修改润色。

### 5. 笔记管理：Notion
All-in-one的工作空间，适合管理写作素材、灵感笔记和研究资料。

### 6. 专注模式：Cold Turkey Writer
强制你在完成字数目标前无法退出，对付拖延症的终极武器。

### 7. 文献管理：Zotero
学术写作必备，自动抓取文献信息，一键生成参考文献。

### 8. 图片素材：Unsplash
高质量免费图片库，为你的文章配图增色。

### 9. 数据可视化：Flourish
将数据转化为精美图表，让文章更有说服力。

### 10. 版本管理：Git
不只是程序员的工具，写作者也可以用Git追踪文章修改历史。`,
    category: 'xiezuo-jiqiao',
    categoryName: '写作技巧',
    date: '2026-07-12',
    readTime: 9,
    imageQuery: 'Clean modern desk with laptop showing productivity app, surrounded by minimalist stationery and warm desk lamp, organized creative workspace, amber and ivory tones, editorial product photography with soft natural lighting',
    imageSeq: 'article-07',
  },
  {
    slug: 'gushi-xiezuo-ruannen',
    title: '故事写作入门：如何讲一个让人停不下来的好故事',
    excerpt: '人类天生爱听故事。掌握故事写作的核心要素，无论写小说还是商业文案，都能让你的文字更有吸引力。',
    content: `## 故事的力量

从原始人围坐在篝火旁，到今天我们在手机上刷短视频——人类对故事的渴望从未改变。一个好的故事，能让信息留存率提升22倍。

## 故事的核心要素

### 1. 角色
读者需要一个可以代入的角色。这个角色需要有欲望、有缺陷、有成长。完美的角色让人敬而远之，有缺点的角色让人感同身受。

### 2. 冲突
没有冲突就没有故事。冲突可以是外在的（对抗反派、克服困难），也可以是内在的（克服恐惧、做出选择）。好的冲突让读者揪心。

### 3. 结构
经典的三幕结构：
- 第一幕：建立情境，引入冲突
- 第二幕：冲突升级，角色成长
- 第三幕：高潮对决，结局收尾

### 4. 转变
好的故事必须有转变——角色在经历了一系列事件后，和故事开始时已经不一样了。这种转变让故事有意义。

## 写作技巧

### 展示，而非告知
不要告诉读者"他很伤心"，而是描写他做了什么——"他坐在床边，手中的照片已经被揉皱了。"

### 细节的力量
一个精准的细节，胜过千言万语。选择最能体现人物性格、推动情节的细节。

### 对话的艺术
好的对话不是日常闲聊，每一个字都应该在推进情节或揭示性格。`,
    category: 'chuangyi-linggan',
    categoryName: '创意灵感',
    date: '2026-07-10',
    readTime: 14,
    imageQuery: 'Cozy reading nook with vintage typewriter and scattered manuscript pages, warm golden hour light streaming through window, nostalgic creative atmosphere, amber and sepia tones, artistic editorial photography with dreamy soft focus',
    imageSeq: 'article-08',
  },
  {
    slug: 'ppt-yanjiang-gao',
    title: '从PPT到演讲：如何把文字转化为有力的口头表达',
    excerpt: '写好PPT只是第一步，如何将书面内容转化为打动人心的演讲才是关键。本文分享演讲稿写作的核心技巧。',
    content: `## 写与说的差异

书面语和口语有本质不同。书面语追求精确和复杂度，口语追求简洁和感染力。从PPT到演讲，需要一次"翻译"。

## 演讲稿写作原则

### 1. 一句话核心
你的整个演讲，应该能用一句话概括。如果做不到，说明你想说的太多，需要精简。

### 2. 三的法则
人类大脑最容易记住三个要点。无论是整场演讲还是每个章节，控制在三个要点以内。

### 3. 故事化表达
用故事包装你的观点。人们会忘记你说过的数据，但会记住你讲过的故事。

### 4. 互动设计
好的演讲不是独角戏。设计提问、举手调查等互动环节，让听众参与进来。

## 结构设计

### 开头：30秒抓住注意力
- 一个惊人的数据
- 一个引人深思的问题
- 一个简短的故事

### 主体：层层递进
每个观点用"观点-理由-案例"的结构展开。

### 结尾：余音绕梁
回到开头的问题，给出答案。或者用一个金句收尾，让听众带着这句话离开。

## 排练技巧

- 大声朗读，找出拗口的句子
- 录音回听，检查节奏和语气
- 控制在预定时间的80%，预留弹性`,
    category: 'shangye-wenan',
    categoryName: '商业文案',
    date: '2026-07-08',
    readTime: 10,
    imageQuery: 'Professional speaker at modern podium with warm stage lighting, engaged audience in soft focus, corporate event atmosphere, confident presentation style, amber and charcoal tones, editorial event photography',
    imageSeq: 'article-09',
  },
];

export const reviews = [
  {
    name: '李教授',
    role: '某高校文学院教授',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20scholar%20portrait%20with%20warm%20smile%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '17一起草是我推荐给学生的最佳写作辅助平台。内容质量高，覆盖了从基础写作到学术论文的全方位指导，对提升学生的写作能力帮助很大。',
    rating: 5,
  },
  {
    name: '王主编',
    role: '资深自媒体人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20editor%20portrait%20with%20confident%20expression%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '做自媒体5年了，17一起草的内容营销板块给了我很多启发。从选题到标题，从结构到排版，每一篇文章都是干货。',
    rating: 5,
  },
  {
    name: '张同学',
    role: '985高校研究生',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%20with%20glasses%20and%20friendly%20smile%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '学术写作板块帮我顺利完成了硕士论文。文献综述、研究方法、格式规范，每一步都有详细指导，太实用了。',
    rating: 5,
  },
  {
    name: '陈经理',
    role: '互联网公司市场总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20portrait%20with%20warm%20professional%20smile%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '商业文案板块的质量超出预期。我们团队用17一起草的方法论优化了品牌文案，转化率提升了40%。',
    rating: 5,
  },
  {
    name: '刘老师',
    role: '中学语文教师',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20Chinese%20female%20teacher%20portrait%20with%20warm%20smile%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '我把17一起草的文章作为课堂补充材料，学生们非常喜欢。特别是创意写作训练方法，激发了孩子们的写作兴趣。',
    rating: 5,
  },
  {
    name: '赵先生',
    role: '自由撰稿人',
    avatar: 'https://readdy.ai/api/search-image?query=Creative%20Chinese%20male%20writer%20portrait%20with%20thoughtful%20expression%2C%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-06&orientation=squarish',
    content: '从17一起草学到了很多实战技巧。写作生产力工具那篇文章改变了我的工作流，现在每天能多产出2000字。',
    rating: 4,
  },
];

export const stats = [
  { label: '累计用户', value: '500,000+' },
  { label: '优质文章', value: '10,000+' },
  { label: '内容分类', value: '6大类' },
  { label: '用户好评率', value: '98.5%' },
];

export const features = [
  {
    icon: 'ri-book-open-line',
    title: '海量创作资源',
    description: '覆盖写作技巧、创意灵感、内容营销、学术写作等全方位内容，满足不同场景的写作需求。',
  },
  {
    icon: 'ri-team-line',
    title: '在线写作协作',
    description: '支持多人实时协作编辑，告别邮件来回传输，让团队创作更高效、更流畅。',
  },
  {
    icon: 'ri-brain-line',
    title: 'AI智能辅助',
    description: '智能纠错、风格优化、灵感推荐，AI助手全程陪伴你的创作之旅。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: '数据分析洞察',
    description: '实时追踪文章数据，了解读者偏好，用数据驱动内容优化决策。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '原创保护机制',
    description: '智能查重与原创认证，保护每一位创作者的智力成果不被侵犯。',
  },
  {
    icon: 'ri-rocket-line',
    title: '高效发布分发',
    description: '一键发布到多个平台，统一管理内容矩阵，让好内容触达更多读者。',
  },
];

export const faqs = [
  {
    question: '17一起草是免费的吗？',
    answer: '17一起草提供丰富的免费内容资源，包括写作技巧文章、创意训练方法等。部分高级功能（如在线协作、AI辅助等）提供付费套餐，但基础写作资源永久免费开放。',
  },
  {
    question: '如何开始使用17一起草？',
    answer: '非常简单！只需注册一个账号，即可立即访问所有免费内容资源。根据你感兴趣的写作领域，浏览对应分类的文章，开始你的创作之旅。',
  },
  {
    question: '17一起草适合哪些人群？',
    answer: '17一起草面向所有需要写作的人群，包括但不限于：学生（论文、作业）、自媒体创作者、职场人士（报告、文案）、学术研究者、自由撰稿人、创业者（商业计划书）等。',
  },
  {
    question: '平台上的文章质量如何保证？',
    answer: '我们建立了严格的文章审核机制，所有内容均由资深写作者和行业专家创作或审核。每篇文章都经过多轮校对和内容质量评估，确保信息的准确性和实用性。',
  },
  {
    question: '可以投稿自己的文章吗？',
    answer: '当然可以！17一起草欢迎优质原创内容投稿。我们的编辑团队会审核您的稿件，通过后将在平台发布，并为您带来曝光和影响力。',
  },
];